const MAX_FILE_SIZE = 104857600 // 100 MB
const MAX_BATCH_SIZE = 524288000 // 500 MB
const FILE_LIMIT = 50

export const validateFiles = files => {
  const result = {}

  if (files.length > FILE_LIMIT) {
    result.validFiles = []
    result.error = true
    result.errorMessage = `You have attempted to upload ${files.length} files and there is an upload limit of ${FILE_LIMIT} files.`
    return result
  }
  let totalFilesSize = 0
  const invalidFileNames = []
  const validFiles = []
  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      invalidFileNames.push(' - ' + file.name + ' (' + Math.round(file.size * 100 / MAX_FILE_SIZE) + 'MB)' + '\n')
      continue
    }
    validFiles.push(file)
    totalFilesSize += parseInt(file.size, 10)
  }
  if (totalFilesSize > MAX_BATCH_SIZE) {
    result.validFiles = []
    result.error = true
    result.errorMessage =
      `Your upload cannot have a total size greater than ${MAX_BATCH_SIZE / 1024 / 1024}MB. Please upload your files in smaller groups, and make sure each file is smaller than ${MAX_FILE_SIZE / 1024 / 1024}MB.`
    return result
  }
  if (invalidFileNames.length) {
    result.invalidFiles = invalidFileNames
    result.error = true
    result.errorMessage =
      `The maximum file size limit for uploads is ${MAX_FILE_SIZE / 1024 / 1024}MB. The following file(s) were not uploaded because they exceed the maximum file size.`
  }
  result.validFiles = validFiles
  return result
}
